import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'cognitive_goal'

const OPTIONS = [
  {
    value: 'memory-recall',
    translationKey: 'pages.onboarding.cognitiveGoal.options.memoryRecall',
  },
  {
    value: 'focus-attention',
    translationKey: 'pages.onboarding.cognitiveGoal.options.focusAttention',
  },
  {
    value: 'word-finding',
    translationKey: 'pages.onboarding.cognitiveGoal.options.wordFinding',
  },
  {
    value: 'mental-speed',
    translationKey: 'pages.onboarding.cognitiveGoal.options.mentalSpeed',
  },
]

const answers: AnswerType[] = [
  {
    emoji: '🧠',
    title: 'pages.onboarding.cognitiveGoal.options.memoryRecall',
    value: 'memory-recall',
  },
  {
    emoji: '🎯',
    title: 'pages.onboarding.cognitiveGoal.options.focusAttention',
    value: 'focus-attention',
  },
  {
    emoji: '💬',
    title: 'pages.onboarding.cognitiveGoal.options.wordFinding',
    value: 'word-finding',
  },
  {
    emoji: '⚡',
    title: 'pages.onboarding.cognitiveGoal.options.mentalSpeed',
    value: 'mental-speed',
  },
]

export default function CognitiveGoalPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const answerValue = input.value

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Which cognitive area do you most want to improve?',
      answer_key: answerValue,
      answer: answerValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.cognitiveGoal.heading"
      onSubmit={onSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
